import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';
import type { GenericResponse, UpdateCardMetadataRequest } from '@/features/card/types/card.types';

export const metadataUpdateService = {
    async updateCardMetadata(payload: UpdateCardMetadataRequest, card_uuid: string): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return apiClient.post<GenericResponse>(
            API_ENDPOINTS.metadata.update(card_uuid),
            { data: { data: payload } },
            { headers: newHeaders }
        );
    },
};
